/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
// @ts-expect-error glowingblue/orell-bookshelf ships no typings (remove this once it does)
import BookListState from 'flarum/orell-bookshelf/states/BookListState';

export default function () {
	extend(BookListState.prototype, 'sortMapItems', function (items) {
		items.add('bestRated', '-avgRating', 96);
		items.add('worstRated', 'avgRating', 95);
	});
}
